let initPromise: Promise<void> | null = null

async function ensureFeedbackIntegration() {
  const { feedbackIntegration, getClient } = await import('@sentry/browser')

  const client = getClient()
  if (client) {
    client.addIntegration(
      feedbackIntegration({
        autoInject: false,
        colorScheme: 'light',
        enableScreenshot: false,
      }),
    )
  }
}

export async function loadSentryFeedback() {
  if (!initPromise) {
    initPromise = ensureFeedbackIntegration()
  }
  await initPromise

  const { getFeedback } = await import('@sentry/browser')
  return getFeedback()
}
